import { auth } from 'utils'

export default async (to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth === true)

  try {
    const response = await auth.attemptViaSession()

    if (to.meta && to.meta.access && response && response.data && response.data.data) {
      if (!to.meta.access.includes(response.data.data.role)) {
        throw new Error('Unauthorized access.')
      }
    }

    next()
  } catch (error) {
    if (requiresAuth) {
      await auth.redirectOnSessionExpired()
    } else {
      next()
    }
  }
}
